<template>
  <v-dialog v-model="dialog">
    <v-card>
      <v-card-title class="subtitle-1">
        {{ infoDevice.name }}
      </v-card-title>
      <v-card-text>
        <v-switch
          v-model="infoDevice.is_set"
          class="mt-1"
          dense
          label="通知 オフ / オン"
          @change="changeIsSet"
        >
          <template v-slot:label>
            <p class="caption mb-0">通知 オフ / オン</p>
          </template>
        </v-switch>
        <v-switch
          v-show="infoDevice.is_alert"
          v-model="infoDevice.is_notification_disabled"
          class="mt-1"
          dense
          @change="changeIsNotificationDisabled"
        >
          <template v-slot:label>
            <p class="caption mb-0">
              {{
                alertDisabledTime(infoDevice.alert_disabled_time)
              }}後まで通知をしない
            </p>
          </template>
        </v-switch>
        <p v-if="infoDevice.is_alert" class="my-1 caption">
          ※通知オフで停止するとオンにし忘れることがありますので、「〇時間後まで通知をしない」をオンにして停止してください。
        </p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { postUserDevice, putUserDevice, deleteUserDevice } from '@/api'

export default {
  name: 'DeviceListInformation',
  computed: {
    ...mapGetters(['infoDevice', 'infoDeviceId']),
    dialog: {
      get() {
        return this.infoDeviceId !== ''
      },
      set() {
        this.unsetInfoDeviceId()
      }
    }
  },
  methods: {
    ...mapActions(['unsetInfoDeviceId', 'updateDeviceBy']),
    async changeIsSet(isSet) {
      this.updateDeviceBy({
        id: this.infoDeviceId,
        key: 'is_set',
        value: isSet
      })
      try {
        if (isSet) {
          await postUserDevice(this.$route.params.provider, this.infoDeviceId)
        } else {
          await deleteUserDevice(this.$route.params.provider, this.infoDeviceId)
        }
      } catch (e) {
        console.error(e)
        alert('サーバエラーが発生しました。ログイン画面に遷移します。')
        this.$router.push('/auth/sign-out')
        return
      }
    },
    async changeIsNotificationDisabled(isNotificationDisabled) {
      this.updateDeviceBy({
        id: this.infoDeviceId,
        key: 'is_notification_disabled',
        value: isNotificationDisabled
      })
      try {
        await putUserDevice(
          this.$route.params.provider,
          this.infoDeviceId,
          isNotificationDisabled,
          this.infoDevice.alert_disabled_time
        )
      } catch (e) {
        console.error(e)
        alert('サーバエラーが発生しました。ログイン画面に遷移します。')
        this.$router.push('/auth/sign-out')
        return
      }
    },
    alertDisabledTime(second) {
      const min = Math.floor(second / 60) % 60
      const hour = Math.floor(second / 3600)
      let time = ''
      if (hour > 0) {
        time += hour + '時間'
      }
      if (min > 0) {
        time += min + '分'
      }
      return time
    }
  }
}
</script>
